import { FC } from 'react'
import dynamic from 'next/dynamic'
import { Constants } from 'common/utils'
import Heading from 'components/Heading'
import Strings from 'project/localisation' // we need this to make JSX compile
import cn from 'classnames'
import { Tenant } from 'common/tenant'

// Dynamic for the same reason as Footer: keeps next-share out of _app.
const SocialLinks = dynamic(() => import('components/SocialLinks'))

type CompanyInformationType = {
  tenant?: Tenant
  className?: string
}

const CompanyInformationCard: FC<CompanyInformationType> = ({
  tenant = Tenant.UK,
  className,
}) => {
  const au = tenant === Tenant.AU
  const data = Constants.companyInformation
  const phone = au ? data.phoneAu : data.phone
  const email = au
    ? Constants.companyInformation.emailAu
    : Constants.companyInformation.email
  return (
    <div className={className}>
      <span className='text-small d-block mt-sm-0 mt-2'>
        {au
          ? Strings.openingHoursDescriptionAu
          : Strings.openingHoursDescription}
      </span>
      <div className='d-flex flex-column'>
        <a
          target="_blank"
          className='text-link color-blue text-small'
          href={`https://help.hoxtonmix.com/en/article/bank-holiday-closures-9bz14x/`}
        >
          Holiday opening hours
        </a>
        <a className='text-link color-blue text-small' href={`tel:${phone}`}>
          {phone}
        </a>
        <a
          href={`mailto:${email}`}
          className='text-link color-blue mt-0 pt-0 text-small d-block text-decoration-none'
        >
          {email}
        </a>
      </div>
    </div>
  )
}

export default CompanyInformationCard
